module.exports = __webpack_public_path__ + "img/ccLogos.1961d921.jpg";